var map = {
	"./add1.svg": "51d7",
	"./alert-icon.svg": "86dd",
	"./biometric-logo-mini.svg": "4190",
	"./biometric-logo.svg": "3ec6",
	"./branches-logo-active.svg": "73d6",
	"./branches-logo.svg": "27b5",
	"./checked-icon.svg": "49cd",
	"./devices-logo-active.svg": "4743",
	"./devices-logo.svg": "a28a",
	"./groups-logo-active.svg": "7733",
	"./groups-logo.svg": "8f3d",
	"./guest-logo-active.svg": "7126",
	"./guest-logo.svg": "49a9",
	"./logout-icon.svg": "7ef9",
	"./more-icon.svg": "b2e8",
	"./page-not-found-logo.svg": "4b4b",
	"./page-not-found.svg": "0be0",
	"./reports-logo-active.svg": "8369",
	"./reports-logo.svg": "4055",
	"./roles-logo-active.svg": "c6cb",
	"./roles-logo.svg": "84c7",
	"./schedule-logo-active.svg": "c57b",
	"./schedule-logo.svg": "7bbf",
	"./stuff-logo-active.svg": "1b1d",
	"./stuff-logo.svg": "7278",
	"./user-icon.svg": "d4b3",
	"./users-logo-active.svg": "21ae",
	"./users-logo.svg": "acd0",
	"./visits-logo-active.svg": "17a5",
	"./visits-logo.svg": "4fde"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";